import { LazyImport, LazyModule } from 'owa-bundling';

const lazyModule = new LazyModule(
    () => import(/* webpackChunkName: "AutomatedMessage"*/ './lazyIndex')
);

export const lazySendAutomatedMessage = new LazyImport(lazyModule, m => m.sendAutomatedMessage);

export { default as MessageDetails } from './schema/MessageDetails';
export { default as AttachmentDetails } from './schema/AttachmentDetails';
